
import {DigitizationCategories, DigitizationTools} from "../ToolRegistry.js";
import {totalPolylineLength, offsetPointAlongPolyline, labelOffsetDistance} from "../geometry/measurementGeometry.js";

import {t, T} from "../i18n/index.js";
// New top-level Digitalisering section (task: "et seperat menupunkt")
// alongside Grundlæggende geometri/Beregnet geometri/Specialiseret
// registrering - registered here (the first of the three Målinger tools
// to load, per digitization/index.js's own import order) rather than
// duplicated in each of the three tool files.
DigitizationCategories.register({id: "measurement", name: T("Målinger"), order: 3});

// User-requested: every length-based label value shows at least millimeter
// precision (task: "mindst vises med millimeter som mindste værdi").
export function formatLength(meters){
	return `${meters.toFixed(3)} m`;
}

// Mål afstand: open-ended polyline capture (identical interaction to the
// existing Linje tool - left-click adds a point, right-click finishes),
// but with the Målinger-specific label contract (task): no per-vertex
// coordinate labels; a length label on every segment; one summary label
// with name/total length/segment count, recomputed live via
// FeatureVisual's own enableSegmentLabels()/enableSummaryLabel() - see
// DigitizationModule.js's startInsertion() for how these declarative
// fields get wired onto the visual. No customCapture needed: the capture
// INTERACTION itself is the same generic multi-point flow every basic
// geometry tool already uses.
export const DistanceTool = {
	id: "digitize_distance",
	name: T("Mål afstand"),
	category: "measurement",
	kind: "measurement",
	toolbarGroup: "measurement",
	toolbarOrder: 10,
	icon: "measure_distance.svg",
	resultGeometryType: "LineString",
	maxPoints: Infinity,
	tooltip: T("Mål den samlede afstand langs en række punkter i punktskyen."),
	instructions: T("Venstreklik for at placere målingens punkter. Højreklik for at afslutte."),

	suppressVertexLabels: true,
	// a/b here are the vertex spheres' own THREE.Vector3 positions (see
	// FeatureVisual._layoutSegmentLabels()), so the native .distanceTo() is
	// simplest - the shared pure-math module is used for the SUMMARY
	// below, which works from plain [x,y,z] arrays (rawCoordinates()).
	segmentLabelFormat: (a, b) => formatLength(a.distanceTo(b)),

	summaryLabelFormat(raw, visual){
		if(raw.length < 2) return null;
		const total = totalPolylineLength(raw);
		const segmentCount = raw.length - 1;
		return [
			visual.name,
			t("Samlet længde: {0}", formatLength(total)),
			t("Antal segmenter: {0}", segmentCount),
		];
	},
	summaryLabelAnchor(raw){
		// User-requested: "midt på den målte linje" (the middle of the
		// measured line) - the point at half the PATH length, not the last
		// clicked point (previous behaviour) or a straight endpoint average -
		// offset sideways (same fix/helpers as the plain Linje tool - see
		// basicGeometryTools.js) so the label clears the line itself rather
		// than sitting exactly on top of it.
		const total = totalPolylineLength(raw);
		const offset = offsetPointAlongPolyline(raw, 0.5, labelOffsetDistance(total));
		return {x: offset[0], y: offset[1], z: offset[2]};
	},
};

DigitizationTools.register(DistanceTool);
